import React from 'react';

import PrivacyPolicyContent from 'sections/privacyPolicy/PrivacyPolicyContent';
import PrivacyPolicyTop from 'sections/privacyPolicy/PrivacyPolicyTop';
import { SEO } from 'hooks/useSeo';
import { PageUrl } from 'const/page-url';

const PrivacyPolicy: React.FC = () => {
    return (
        <React.Fragment>
            <SEO
                title="プライバシーポリシー | OHANA AI"
                description="OHANA AIにおける個人情報の取扱い方針(取得する情報、利用目的、第三者提供、開示請求の手続き等)を記載しています。"
                path={PageUrl.PrivacyPolicy.urlWithSlash}
            />
            <PrivacyPolicyTop />
            <PrivacyPolicyContent />
        </React.Fragment>
    );
};

export default PrivacyPolicy;
